import React from 'react';
import _ from 'lodash';

class ShootPageSubHeader extends React.Component {
	render() {
		return (
			<div className="shoot-page-sub-header-container">
				{_.map(this.props.filterList, (item, key) => {
					return (
						<div
							className={
								'sub-filter-item' + (this.props.currFilter === key ? ' active' : '')
							}
							onClick={() => {
								if (this.props.currFilter !== key) {
									this.props.onChangeFilter(key);
								}
							}}
						>
							<span className="title">{key}</span>
							<span className="title">{_.size(item)}</span>
						</div>
					);
				})}
			</div>
		);
	}
}

export default ShootPageSubHeader;
